<div class="common-input-wrapper">
  <div class="label-with-tooltip">
    <label class="labelColor" for="{{ label }}" id="{{ label }}" *ngIf="label">{{ label }}</label>
    <span *ngIf="showTooltip || tooltipText" class="tooltip-wrapper">
      <span [placement]="tooltipPlacement" [tooltipClass]="tooltipClass" [ngbTooltip]="tooltipText">
        <a class="info-icon">
          <span>
            <img
              [src]="tooltipIcon"
              [width]="tooltipIconWidth"
              [height]="tooltipIconHeight"
              alt="Info"
            />
          </span>
        </a>
      </span>
    </span>
  </div>

  <div class="services-form">
    <input
      [type]="getInputType()"
      [placeholder]="placeholder"
      [attr.maxlength]="maxLength"
      [disabled]="isDisabled"
      [value]="value"
      [name]="name"
      (input)="onInput($event)"
      (keydown)="onKeyDown($event)"
      (keypress)="onKeyPress($event)"
      (keyup)="onKeyUp($event)"
      (blur)="onBlur($event)"
      [class.error]="shouldShowError()"
      (wheel)="$event.preventDefault()"
    />
    <div *ngIf="showPasswordToggle && inputType === 'password'" class="input-group-append">
      <span class="input-group-text" (click)="togglePassword()">
        <img
          [src]="showPassword ? 'assets/images/Eye.png' : 'assets/images/EyeCross.png'"
          alt="Toggle password visibility"
        />
      </span>
    </div>
    <div *ngIf="shouldShowError()" class="input-error">
      {{ getErrorMessage() }}
    </div>
  </div>
</div>
